import { render, staticRenderFns } from "./LinkToCommandsButton.vue?vue&type=template&id=4bd0dcc6&"
import script from "./LinkToCommandsButton.vue?vue&type=script&lang=js&"
export * from "./LinkToCommandsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports